<template>
<div class="card shadow mb-4">
  <!-- Card Header -->
  <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
    <h6 class="m-0 font-weight-bold">{{ $t('Consumption_details') }}</h6>
    <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('home_tooltip_cons_details')"></i>
  </div>
  <!-- End of Card Header -->

  <!-- Card Body -->
  <div class="card-body">
    <div class="container">
      <!-- DONUT CHART -->
      <div class="row py-10">
        <div class="col-12 col-sm-12 col-md-12 text-center">
          <ConsumptionDetailsDonut :data="data" :id="parseInt(0)"></ConsumptionDetailsDonut>
        </div>
      </div>
      <!-- Grid to House -->
      <div class="row py-10 align-items-center">
          <div class="col-md-2 text-center d-none d-md-block">
            <img class="img-fluid center-block" style="max-width:80%" src="../../public/icons/energy-icons/grid.png">
          </div>
          <div class="col-9 col-sm-9 col-md-7">
            <span style="font-weight: 600;">{{ $t('Electric_grid_to_house') }}</span>
            <span style="display:block; color:#999; overflow:hidden">{{ $t('Energy_consumed_from_grid_to_house') }}
              <span v-if="range =='hour'">{{ $t('in_last_hour') }}</span> 
              <span v-if="range =='day'">{{ $t('in_last_24_hours') }}</span> 
              <span v-if="range =='week'">{{ $t('in_last_7_days') }}</span> 
              <span v-if="range =='month'">{{ $t('in_last_30_days') }}</span></span>
          </div>
          <div class="col-3 col-sm-3 col-md-3 text-center">
            <LoadingSpinner v-if="loading"></LoadingSpinner>
            <span v-else class="h4 mb-0 font-weight-bold text-darkorange">{{ Grid_House }}</span> 
            <span style="display:block">kWh</span>
          </div>
      </div>
      <!-- Production to House -->
      <div class="row py-10 align-items-center">
          <div class="col-md-2 text-center d-none d-md-block">
            <img class="img-fluid center-block" style="max-width:80%" src="../../public/icons/energy-icons/production-used.png">
          </div>
          <div class="col-9 col-sm-9 col-md-7">
            <span style="font-weight: 600;">{{ $t('Production_to_house') }}</span>
            <span style="display:block; color:#999; overflow:hidden">{{ $t('Energy_consumed_by_house_from_production') }}
              <span v-if="range =='hour'">{{ $t('in_last_hour') }}</span> 
              <span v-if="range =='day'">{{ $t('in_last_24_hours') }}</span> 
              <span v-if="range =='week'">{{ $t('in_last_7_days') }}</span> 
              <span v-if="range =='month'">{{ $t('in_last_30_days') }}</span></span>
          </div>
          <div class="col-3 col-sm-3 col-md-3 text-center">
            <LoadingSpinner v-if="loading"></LoadingSpinner>
            <span v-else class="h4 mb-0 font-weight-bold text-blue">{{ PV_House }}</span> 
            <span style="display:block">kWh</span>
          </div>
      </div>
      <!-- Battery to House -->
      <div v-if="has_battery" class="row py-10 align-items-center">
        <div class="col-md-2 text-center d-none d-md-block">
          <img class="img-fluid center-block" style="max-width:80%" src="../../public/icons/energy-icons/battery.png">
        </div>
        <div class="col-9 col-sm-9 col-md-7">
          <span style="font-weight: 600;">{{ $t('Battery_to_house') }}</span>
          <span style="display:block; color:#999; overflow:hidden"> {{ $t('Energy_consumed_from_battery_to_house') }}
              <span v-if="range =='hour'">{{ $t('in_last_hour') }}</span> 
              <span v-if="range =='day'">{{ $t('in_last_24_hours') }}</span> 
              <span v-if="range =='week'">{{ $t('in_last_7_days') }}</span> 
              <span v-if="range =='month'">{{ $t('in_last_30_days') }}</span></span>
        </div>
        <div class="col-3 col-sm-3 col-md-3 text-center">
          <LoadingSpinner v-if="loading"></LoadingSpinner>
          <span v-else class="h4 mb-0 font-weight-bold text-green">{{ Batt_House }}</span> 
          <span style="display:block">kWh</span>
        </div>
      </div>
      <!-- Total consumption -->
      <div class="row py-10 align-items-center border-top-1">
        <div class="col-md-2 text-center d-none d-md-block">
          <img class="img-fluid center-block" style="max-width:80%" src="../../public/icons/energy-icons/consumption.png">
        </div>
        <div class="col-9 col-sm-9 col-md-7">
          <span style="font-weight: 600;">{{ $t('Total_Consumption') }}</span>
          <span style="display:block; color:#999; overflow:hidden">{{ $t('Total_energy_consumed') }}
              <span v-if="range =='hour'">{{ $t('in_last_hour') }}</span> 
              <span v-if="range =='day'">{{ $t('in_last_24_hours') }}</span> 
              <span v-if="range =='week'">{{ $t('in_last_7_days') }}</span> 
              <span v-if="range =='month'">{{ $t('in_last_30_days') }}</span></span>
        </div>
        <div class="col-3 col-sm-3 col-md-3 text-center">
          <LoadingSpinner v-if="loading"></LoadingSpinner>
          <span v-else class="h4 mb-0 font-weight-bold text-orange">{{ total_consumption }}</span> 
          <span style="display:block">kWh</span>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Card Body -->
</div>
</template>

<script>
import friendlyFloatingPoint from '../helpers/friendlyFloatingPoint.js'
import ConsumptionDetailsDonut from './ConsumptionDetailsDonut.vue'
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'ConsumptionDetails',
  components:{
    ConsumptionDetailsDonut,
    LoadingSpinner
  },
  computed: {
    data: function(){
      return this.$store.getters.data_consumption[0] || []
    },
    has_battery: function(){
      if (this.$store.getters.user_isAdmin) return this.$store.getters.remote_user_bess
      return this.$store.getters.user_bess
    }, 
    total_consumption: function(){
      if(this.data && this.data.Batt_House != null && this.data.PV_House != null && this.data.Grid_House != null)
        return friendlyFloatingPoint(this.data.Batt_House + this.data.PV_House + this.data.Grid_House)
      else return '-'
    },
    Batt_House: function(){
      if (this.data && this.data.Batt_House != null) return friendlyFloatingPoint(this.data.Batt_House)
      else return '-'
    },
    PV_House: function(){
      if (this.data && this.data.PV_House != null) return friendlyFloatingPoint(this.data.PV_House)
      else return '-'
    },
    Grid_House: function(){
      if (this.data && this.data.Grid_House != null) return friendlyFloatingPoint(this.data.Grid_House)
      else return '-'
    },
    range: function(){
      return this.$store.getters.range
    },
    loading: function(){
      return this.$store.getters.data_loading
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
